import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const DoughnutChat = ({ applicant, screening, evaluation, dropout }) => {



  const doughnutData = {
    datasets: [
      {
        label: 'Applicants',
        data: [applicant, screening, evaluation, dropout],
        backgroundColor: [
          '#005b90',
          '#21D4FD',
          '##005b9071',
          '#f53939'
        ],
        cutout: 70,
      },
    ],
  }
  const chartOptions = {
    responsive: true,
    width: 400, // Set your desired width
    height: 400, // Set your desired height
    cutoutPercentage: 70,
  };
  return (

    <div className='Doughnutcontainer'>
      <Doughnut data={doughnutData} options={chartOptions} />
    </div>
  )
}

export default DoughnutChat;

